module.exports = __webpack_public_path__ + "media/images/top/img_interview_arikou-5b7b3f116c88387d5fa3c6d5a8e525b0.jpg";